var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet solid bordered white" }, [
    _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c("i", { staticClass: "fa fa-bar-chart-o null" }),
        _vm._v(" "),
        _c("span", { staticClass: "null" }, [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tools" }, [
        _c("i", {
          staticClass: "fa fa-download",
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.exportar()
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "portlet-body" }, [
        _c(
          "div",
          { staticClass: "col-lg-7 col-xs-6 col-sm-6" },
          [
            _c("ui-dashboard-charts-no-title", {
              attrs: { id: _vm.idGrafico, heightChart: _vm.heightChart },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-5 col-xs-6 col-sm-6" },
          _vm._l(_vm.obterInfos(), function (item, index) {
            return _c("div", { key: index, staticClass: "col-lg-12" }, [
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "25px",
                    "font-weight": "bold",
                    "text-align": "left",
                  },
                },
                [_vm._v(_vm._s(item.Valor))]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-size": "12px", "text-align": "left" } },
                [_vm._v(_vm._s(item.Nome))]
              ),
              _vm._v(" "),
              _c("br"),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }